export const scrollToNextSection = linkUrl => {
  if (linkUrl) {
    let div;
    try {
      div = document.querySelector(linkUrl);
      const topPoint = div.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ behavior: "smooth", left: 0, top: topPoint });
    } catch {
      return;
    }
  }
};
